import { Box, Grid, Stack, IconButton, Divider } from "@mui/material";
import CustomText from "../components/CustomText";
import CustomTextField from "../components/CustomTextField";
import CustomButton from "../components/CustomButton";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";
import { useFormValidation } from "../hooks/useFormValidation";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaPhone,
  FaWhatsapp,
} from "react-icons/fa";

const FormOurServices = () => {
  const { formData, errors, handleChange, resetForm } = useFormValidation({
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    correo_electronico: "",
    telefono: "",
    mensaje: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const mensaje = `Hola Centro Médico Medam 👋
Me gustaría recibir información sobre sus servicios.

*Nombre:* ${formData.nombre}
*Teléfono:* ${formData.telefono}
*Mensaje:* ${formData.mensaje}`;

    trackEvent("whatsapp_formulario_servicios", {
      page_path: window.location.pathname,
      page_url: window.location.href,
      section: "formulario_servicios",
      label: "Formulario Servicios",
      cta_name: "enviar_whatsapp",
      message_type: "contacto_general",
      value: 1,
    });

    openWhatsApp("5959570961", mensaje, false);

    resetForm();
  };

  return (
    <Grid container sx={design.Container}>
      <Grid size={design.grid12} sx={design.MainWrapper}>
        <Grid container sx={design.ContentWrapper}>
          <Grid size={design.grid6} sx={design.FormColumn}>
            <Box sx={design.Card}>
              <CustomText
                color="#7A2FA4"
                fontWeight={700}
                letterSpacing="3px"
                textTransform="uppercase"
                fontFamily="Nunito"
                fontSize={design.fontSize12}
                textAlign="left"
                width="100%"
                mb={1.5}
              >
                CONTÁCTANOS
              </CustomText>
              <CustomText
                color="#162E84"
                fontWeight={800}
                fontFamily="Nunito"
                textAlign="left"
                fontSize={design.fontSize40}
                lineHeight={1.2}
                width="100%"
              >
                ¿Quieres saber más sobre
                <br />
                nuestros servicios?
              </CustomText>
              <CustomText
                color="#8A8A8A"
                fontFamily="Nunito"
                fontSize={design.fontSize15}
                fontWeight={400}
                textAlign="left"
                lineHeight={1.45}
                width="100%"
                py={design.py}
              >
                Déjanos tus datos y nuestro equipo te contactará con la
                información que necesitas. Tu tranquilidad es nuestra prioridad.
              </CustomText>
              <Box component="form" onSubmit={handleSubmit} sx={design.Form}>
                <Grid container spacing={design.py}>
                  <CustomTextField
                    title=""
                    id="nombre"
                    name="nombre"
                    label="Nombre"
                    type="text"
                    value={formData.nombre}
                    onChange={(e) => handleChange("nombre", e.target.value)}
                    variant="outlined"
                    gridXS={12}
                    grid={4}
                    required
                  />
                  <CustomTextField
                    title=""
                    id="apellido_paterno"
                    name="apellido_paterno"
                    label="Apellido paterno"
                    type="text"
                    value={formData.apellido_paterno}
                    onChange={(e) =>
                      handleChange("apellido_paterno", e.target.value)
                    }
                    variant="outlined"
                    gridXS={12}
                    grid={4}
                    required
                  />
                  <CustomTextField
                    title=""
                    id="apellido_materno"
                    name="apellido_materno"
                    label="Apellido materno"
                    type="text"
                    value={formData.apellido_materno}
                    onChange={(e) =>
                      handleChange("apellido_materno", e.target.value)
                    }
                    variant="outlined"
                    gridXS={12}
                    grid={4}
                    required
                  />
                  <CustomTextField
                    title=""
                    id="correo"
                    name="correo"
                    label="Correo electrónico"
                    type="email"
                    value={formData.correo_electronico}
                    onChange={(e) =>
                      handleChange("correo_electronico", e.target.value)
                    }
                    variant="outlined"
                    grid={6}
                    gridXS={12}
                    required
                    error={!!errors.correo_electronico}
                    helperText={errors.correo_electronico}
                  />
                  <CustomTextField
                    id="telefono"
                    name="telefono"
                    label="Teléfono"
                    title=""
                    type="tel"
                    value={formData.telefono}
                    onChange={handleChange}
                    grid={6}
                    gridXS={12}
                    variant="outlined"
                    required
                    error={!!errors.telefono}
                    helperText={errors.telefono}
                  />
                  <CustomTextField
                    id="mensaje"
                    name="mensaje"
                    label="Escribe tu mensaje"
                    title=""
                    type="text"
                    value={formData.mensaje}
                    onChange={handleChange}
                    grid={12}
                    gridXS={12}
                    rows={4}
                    multiline
                    variant="outlined"
                  />
                </Grid>
                <Box sx={design.FormButtonContainer}>
                  <CustomButton
                    type="submit"
                    variant="contained"
                    color="success"
                    colorTexto="#FFF"
                    backgroundColor="#489E4D"
                    width="100%"
                    height={50}
                    grid={12}
                    gridXS={12}
                    borderRadius={20}
                    style={design.Button}
                    align
                  >
                    Enviar mensaje
                  </CustomButton>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={design.grid6} sx={design.ContactColumn}>
            <Box sx={design.ContactCard}>
              <CustomText
                color="#FFFFFF"
                fontWeight={800}
                fontFamily="Nunito"
                textAlign="left"
                fontSize={design.fontSize35}
                lineHeight={1.2}
                width="100%"
              >
                Encuéntranos también aquí
              </CustomText>
              <CustomText
                color="#FFFFFF"
                fontFamily="Nunito"
                fontSize={{
                  xs: 17,
                  sm: 17,
                  md: 18,
                }}
                lineHeight={1.5}
                textAlign="left"
                mb={2.5}
                mt={1}
                width="100%"
              >
                Síguenos en redes y escríbenos cuando lo necesites.
              </CustomText>
              <CustomText
                color="#FFFFFF"
                textAlign="left"
                fontWeight={600}
                fontFamily="Nunito"
                letterSpacing="1px"
                fontSize={14}
                mb={1}
              >
                REDES SOCIALES
              </CustomText>
              <Stack direction="row" sx={design.socialMedia}>
                {redesSociales.map((red, index) => (
                  <IconButton
                    key={index}
                    sx={design.IconButton}
                    onClick={() => {
                      window.open(
                        red.url,
                        red.url.startsWith("http") ? "_blank" : "_self",
                      );
                    }}
                  >
                    {red.icon}
                  </IconButton>
                ))}
              </Stack>
              <CustomText
                color="#DCDCDC"
                textAlign="left"
                fontWeight={600}
                fontFamily="Nunito"
                letterSpacing="1px"
                fontSize={14}
                mb={1}
              >
                TELÉFONO
              </CustomText>
              <Stack spacing={1.5} mt={1}>
                <Box sx={design.PhoneRow}>
                  <FaPhone style={design.PhoneIcon} />
                  <CustomText
                    color="#FFF"
                    fontSize={{
                      xs: 15,
                      md: 17,
                    }}
                    fontFamily="Nunito"
                    fontWeight={500}
                    textAlign="left"
                  >
                    +52 595 957 0961
                  </CustomText>
                </Box>
              </Stack>
              <Box sx={design.WhatsAppContainer}>
                <CustomButton
                  backgroundColor="#58B947"
                  colorTexto="#FFF"
                  width="100%"
                  height={52}
                  borderRadius={20}
                  style={design.Button}
                  onClick={() =>
                    openWhatsApp(
                      "5959570961",
                      "Hola, me gustaría recibir información sobre sus servicios.",
                      false,
                    )
                  }
                >
                  Contáctanos
                </CustomButton>
              </Box>
              <Divider sx={design.Divider} />
              <CustomText
                color="rgba(255,255,255,.90)"
                lineHeight={1.6}
                fontSize={{
                  xs: 14,
                  sm: 14,
                  md: 15,
                  lg: 16,
                }}
                fontFamily="Nunito"
                textAlign={{ xs: "center", sm: "left", md: "left", lg: "left" }}
                width="100%"
              >
                Centro Médico Medam, Calpulalpan-Texcoco 105, Xala, 56270
                Texcoco de Mora, Méx.
              </CustomText>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FormOurServices;

const design = {
  Container: {
    width: "100%",
    background: "#FFFFFF",
    py: {
      xs: 4,
      sm: 6,
      md: 8,
    },
    px: {
      xs: 2,
      sm: 3,
      md: 4,
      lg: 5,
    },
    boxSizing: "border-box",
  },
  MainWrapper: {
    width: "100%",
  },
  ContentWrapper: {
    width: "100%",
    maxWidth: "1250px",
    margin: "0 auto",
    alignItems: "stretch",
    position: "relative",
    overflow: "visible",
  },
  FormColumn: {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    zIndex: 1,
  },
  Card: {
    width: "100%",
    background: "linear-gradient(135deg, #F4F4F4 0%, #EEEEEE 100%)",
    borderRadius: {
      xs: "20px",
      md: "20px 0 0 20px",
    },
    padding: {
      xs: 2.5,
      sm: 3,
      md: 3.5,
      lg: 4,
    },
    boxSizing: "border-box",
    boxShadow: {
      xs: "0 8px 25px rgba(0,0,0,.06)",
      md: "0 15px 45px rgba(0,0,0,.08)",
    },
    minHeight: {
      md: 550,
    },
    display: "flex",
    flexDirection: "column",
  },
  Form: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginTop: 2,
  },
  FormButtonContainer: {
    width: {
      xs: "100%",
      sm: "70%",
      md: "55%",
      lg: "50%",
    },
    margin: "0 auto",
    mt: {
      xs: 2.5,
      md: 3,
    },
  },
  Button: {
    fontFamily: "Nunito",
    fontSize: {
      xs: 15,
      md: 16,
    },
    fontWeight: 700,
    marginTop: 0,
    transition: "transform .25s ease, box-shadow .25s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 18px rgba(72,158,77,.25)",
    },
  },
  ContactColumn: {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    zIndex: 2,
    position: "relative",
    mt: {
      xs: 3,
      md: 0,
    },
    ml: {
      xs: 0,
      md: -1,
    },
  },
  ContactCard: {
    width: "100%",
    background: "#1F3F92",
    color: "#FFFFFF",
    borderRadius: {
      xs: "20px",
      md: "0 20px 20px 0",
    },
    padding: {
      xs: 3,
      sm: 3.5,
      md: 3.5,
      lg: 4,
    },
    boxSizing: "border-box",
    boxShadow: {
      xs: "0 12px 35px rgba(31,63,146,.18)",
      md: "0 20px 60px rgba(0,0,0,.16)",
    },
    minHeight: {
      md: 550,
    },
    height: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      width: {
        xs: 160,
        md: 220,
      },
      height: {
        xs: 160,
        md: 220,
      },
      top: {
        xs: -100,
        md: -120,
      },
      right: {
        xs: -80,
        md: -100,
      },
      borderRadius: "50%",
      background: "rgba(255,255,255,.035)",
      pointerEvents: "none",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: 120,
      height: 120,
      bottom: -80,
      left: -60,
      borderRadius: "50%",
      background: "rgba(255,255,255,.025)",
      pointerEvents: "none",
    },
  },
  socialMedia: {
    gap: {
      xs: 1.5,
      md: 2,
    },
    mt: 1,
    mb: {
      xs: 2.5,
      md: 3,
    },
    position: "relative",
    zIndex: 1,
  },
  IconButton: {
    width: {
      xs: 44,
      sm: 46,
      md: 48,
    },
    height: {
      xs: 44,
      sm: 46,
      md: 48,
    },
    backgroundColor: "rgba(255,255,255,.12)",
    color: "#FFFFFF",
    transition: "all .25s ease",
    "&:hover": {
      backgroundColor: "#58B947",
      transform: "translateY(-3px)",
      boxShadow: "0 6px 15px rgba(0,0,0,.15)",
    },
    "& svg": {
      fontSize: {
        xs: 20,
        md: 23,
      },
    },
  },
  PhoneRow: {
    display: "flex",
    alignItems: "center",
    gap: {
      xs: 1.5,
      md: 2,
    },
    py: 0.5,
    position: "relative",
    zIndex: 1,
  },
  PhoneIcon: {
    color: "#FFFFFF",
    fontSize: {
      xs: 19,
      md: 22,
    },
    minWidth: 22,
  },
  WhatsAppContainer: {
    width: {
      xs: "100%",
      sm: "75%",
      md: "65%",
      lg: "58%",
    },
    mt: {
      xs: 3,
      md: 3,
    },
    position: "relative",
    zIndex: 1,
  },
  Divider: {
    width: "100%",
    my: {
      xs: 2.5,
      md: 2.5,
    },
    borderColor: "rgba(255,255,255,.8)",
    position: "relative",
    zIndex: 1,
  },
  py: { xs: 2, md: 2.5 },
  fontSize12: { xs: 11, sm: 12, md: 12, lg: 12 },
  fontSize40: { xs: 29, sm: 32, md: 35, lg: 40 },
  fontSize35: { xs: 23, sm: 30, md: 32, lg: 35 },
  fontSize15: { xs: 15, sm: 16, md: 16, lg: 17 },
  grid12: { xs: 12 },
  grid6: { xs: 12, md: 6 },
};

const socialIconStyle = {
  fontSize: 24,
  color: "#FFF",
};

const redesSociales = [
  {
    icon: <FaInstagram style={socialIconStyle} />,
    url: "https://www.instagram.com/centromedico_medam?igsh=ajhiYnFmenJjMXBo",
    type: "instagram",
  },
  {
    icon: <FaFacebookF style={socialIconStyle} />,
    url: "https://www.facebook.com/share/19EGRopCww/?mibextid=wwXIfr",
    type: "facebook",
  },
  {
    icon: <FaEnvelope style={socialIconStyle} />,
    url: "mailto:contacto@centromedicomedam.com",
    type: "mail",
  },
];
